export const EMAIL_VERIFIED = 'EMAIL_VERIFIED';
export const EMAIL_VERIFICATION_REQUIRED = 'EMAIL_VERIFICATION_REQUIRED';
export const EMAIL_VERIFICATION_V3_REQUIRED = 'EMAIL_VERIFICATION_V3_REQUIRED';
export const INVALID_ENTITY = 'INVALID_ENTITY';
export const INVALID_REZDY_LOGIN = 'INVALID_REZDY_LOGIN';
export const INVALID_IDENTITY_PROVIDER_SIGNUP = 'INVALID_IDENTITY_PROVIDER_SIGNUP';

export const EXPIRED_REFRESH_TOKEN = 'EXPIRED_REFRESH_TOKEN';
export const INVALID_VERIFICATION_CODE = 'INVALID_VERIFICATION_CODE';
export const CHANGE_EMAIL_REQUEST_REQUIRED = 'CHANGE_EMAIL_REQUEST_REQUIRED';
